module.exports = __webpack_public_path__ + "img/everything1.783f9356.png";